import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import {
  hasAuthTokenExpired,
  appendStateToLoginUrl,
  getAuthToken,
  getIsAuthenticated,
} from "@/features/shared/features/authentication";

const withAuthentication = (WrappedComponent: React.ComponentType) => {
  const WithAuthentication = () => {
    const location = useLocation();
    // We use selectors instead of the store directly to avoid re-renders
    const isAuthenticated = getIsAuthenticated();
    const authToken = getAuthToken();

    if (!isAuthenticated || hasAuthTokenExpired(authToken)) {
      return <Navigate to={appendStateToLoginUrl(location.pathname)} />;
    }

    return <WrappedComponent />;
  };

  return WithAuthentication;
};

export default withAuthentication;
